window.addEventListener('load', function () {

  function initF6(section, retry) {
    if (!section) return;
    var el = section.querySelector('.f6-swiper');
    if (!el) return;

    if (typeof window.Swiper === 'undefined') {
      if (retry < 30) { setTimeout(function () { initF6(section, retry + 1); }, 100); }
      return;
    }
    if (el.__f6Swiper) return;

    var swiper = new window.Swiper(el, {
      loop: true,
      speed: 500,
      autoplay: { delay: 3500, disableOnInteraction: false },
      pagination: {

        el: section.querySelector('.f6-dots'),
        clickable: true
      }
    });
    el.__f6Swiper = swiper;

    var $section = $(section);
    var thumbList = section.querySelector('.f6-thumbs');

    // Thumb của slide đang chạy phải sáng + lộ trọn trong cột (cột chỉ chứa 4, dư thì cuộn)
    function syncThumb() {
      if (!thumbList) return;
      var thumb = thumbList.querySelector('.f6-thumb[data-index="' + swiper.realIndex + '"]');
      $(thumbList).find('.f6-thumb').removeClass('active');
      if (!thumb) return;
      thumb.classList.add('active');

      var top = thumb.offsetTop;
      var bottom = top + thumb.offsetHeight;
      if (top < thumbList.scrollTop) thumbList.scrollTop = top;
      else if (bottom > thumbList.scrollTop + thumbList.clientHeight) thumbList.scrollTop = bottom - thumbList.clientHeight;
    }
    swiper.on('slideChange', syncThumb);
    syncThumb();

    $section.on('click', '.f6-thumb', function (e) {
      e.preventDefault();
      var idx = parseInt($(this).attr('data-index'), 10) || 0;
      if (swiper && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(idx);
      }
    });

    $section.on('click', '.f6-tab', function (e) {
      e.preventDefault();
      $section.find('.f6-tab').removeClass('active');
      $(this).addClass('active');
    });
  }

  initF6(document.querySelector('#x5-frame6.MS__pc'), 0);
  initF6(document.querySelector('#x5-frame6.MS__mb'), 0);
});
